var React = require('react');

function BodyPart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1377.225,1320.5a20.378,20.378,0,0,1,5.635,6.908c1.467,2.925,1.719,6.386-2.374,8.092a4.336,4.336,0,0,0,1.424-4.27,8.788,8.788,0,0,0-.38-1.133,10.222,10.222,0,0,0-2.534-3.463c.153,2.24-.207,3.9-1.12,4.932a3.322,3.322,0,0,0-1.233-2.13c-.635,1.4-1.326,2.852-1.233,3.587.039,1.071.987,1.647,1.816,2.476-1.529-.38-3.153-.79-3.913-2.609C1371.5,1328.567,1377.225,1323.761,1377.225,1320.5Z","transform":"translate(-1372.534 -1320)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1"}));
}

BodyPart.defaultProps = {"width":"11.806","height":"16","viewBox":"0 0 11.806 16"};

module.exports = BodyPart;

BodyPart.default = BodyPart;
